import {
  Box,
  Card,
  Typography,
  Container,
  Divider,
  Button,
  FormControl,
  OutlinedInput,
  InputAdornment,
  styled,
} from '@mui/material'
import { Helmet } from 'react-helmet-async'
import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone'

import { useTranslation } from 'react-i18next'

const MainContent = styled(Box)(
  () => `
    height: 100%;
    display: flex;
    flex: 1;
    overflow: auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`,
)

const OutlinedInputWrapper = styled(OutlinedInput)(
  ({ theme }) => `
    background-color: ${theme.colors.alpha.white[100]};
`,
)

const ButtonSearch = styled(Button)(
  ({ theme }) => `
    margin-right: -${theme.spacing(1)};
`,
)

function Status404() {
  const { t }: { t: any } = useTranslation()

  return (
    <>
      <Helmet>
        <title>Placebet sitio no existe</title>
      </Helmet>
      <MainContent>
        <Container maxWidth="md">
          <Box textAlign="center">
            <img alt="404" height={180} src="/static/images/status/404.svg" />
            <Typography
              variant="h2"
              sx={{
                my: 2,
              }}
            >
              {t('El sitio solicitado no existe.')}
            </Typography>
            <Typography
              variant="h4"
              color="text.secondary"
              fontWeight="normal"
              sx={{
                mb: 4,
              }}
            >
              {t('Sitio no encontrado!')}
            </Typography>
          </Box>
          <Container maxWidth="sm">
            <Card
              sx={{
                textAlign: 'center',
                mt: 3,
                p: 4,
              }}
            >
              {/* <FormControl variant="outlined" fullWidth>
                <OutlinedInputWrapper
                  type="text"
                  placeholder={t('Buscar aqui...')}
                  endAdornment={
                    <InputAdornment position="end">
                      <ButtonSearch variant="contained" size="small">
                        {t('Buscar')}
                      </ButtonSearch>
                    </InputAdornment>
                  }
                  startAdornment={
                    <InputAdornment position="start">
                      <SearchTwoToneIcon />
                    </InputAdornment>
                  }
                />
              </FormControl>
              <Divider
                sx={{
                  my: 4
                }}
              >
                OR
              </Divider> */}
              <Button href="/" variant="outlined">
                {t('Retornar')}
              </Button>
            </Card>
          </Container>
        </Container>
      </MainContent>
    </>
  )
}

export default Status404
